<aside class="sidebar">
    <div class="d-flex align-items-center justify-content-between">
        <h2 class="sidebar-title">{{ title }}</h2>
        <button class="sidebar-button" (click)="toggleMenu()">
            <span>{{ isCollapsed ? "Exibir" : "Ocultar" }} Menu</span>
            <fa-icon [icon]="icon"></fa-icon>
        </button>
    </div>
    <nav class="sidebar-nav" [ngbCollapse]="isCollapsed">
        <a
            class="sidebar-link"
            [class.sidebar-link-active]="verifyActiveRoute(row.route)"
            [routerLink]="row.route"
            [target]="row.route === '/courts-dashboard' ? '_blank' : '_self'"
            (click)="onLinkClick()"
            *ngFor="let row of menu"
        >
            <span>{{ row.label }}</span>
        </a>
    </nav>
</aside>
